import React from 'react'
import { Loading } from '@winnin/winnin_ui.components.loading'

import Error from 'components/Error'
import GenericEmptyState from 'components/GenericEmptyState'
import { useTranslate } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

function DefaultEmptyComponent() {
  const t = useTranslate()
  return (
    <GenericEmptyState title={t(TOLGEE_GLOBALS.noDataFound)} description={t(TOLGEE_GLOBALS.noDataFoundMessageSmall)} />
  )
}

export interface ILoadingErrorWrapper {
  loading: boolean
  error: boolean | Record<string, any>
  isEmpty?: boolean
  refetch: () => void
  children?: JSX.Element
  skeletonComponent?: any
  emptyComponent?: any
  className?: string
}

export default function LoadingErrorWrapper({
  loading,
  error,
  isEmpty,
  refetch,
  children,
  skeletonComponent,
  emptyComponent = DefaultEmptyComponent,
  className,
}: ILoadingErrorWrapper) {
  const t = useTranslate()

  if (loading) {
    const Skeleton = skeletonComponent ?? (Loading as any)
    return <Skeleton />
  }
  if (error) {
    return (
      <Error
        errorMessage={t(TOLGEE_GLOBALS.errorTextHeader)}
        handleError={refetch}
        buttonText={t(TOLGEE_GLOBALS.retry)}
        className={className}
      />
    )
  }
  if (isEmpty) {
    const EmptyComponent = emptyComponent
    return <EmptyComponent />
  }

  return children
}
